import { render } from "./teacher_register.vue?vue&type=template&id=a32514d6&scoped=true"
import script from "./teacher_register.vue?vue&type=script&lang=js"
export * from "./teacher_register.vue?vue&type=script&lang=js"

import "./teacher_register.vue?vue&type=style&index=0&id=a32514d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a32514d6"]])

export default __exports__